import React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import AcademyAdvantages from '@components/AcademyAdvantages/AcadamyAdvantages';
import AcademyProductsTemplate from '@components/AcademyProducts/AcademyProducts';
import FooterTemplate from '@components/Footer/Footer';
import HeaderTemplate from '@components/Header/Header';
import useTranslation from '@hooks/useTranslation';
import HeroTemplate from '@ui/Hero/Hero';
import { IS_PROD } from '../constants';
import { IAcademyItem } from '../interfaces/Calendar';
import { calendarApi } from '../services/calendar.service';

interface IAcademy {
    events: IAcademyItem[];
    eventsCount: number;
}

const Academy: NextPage<IAcademy> = ({ events, eventsCount }) => {
    const { t } = useTranslation();

    return (
        <>
            <NextSeo title={t('seo.academy.title')} description="" noindex={!IS_PROD} nofollow={!IS_PROD} />
            <HeaderTemplate />
            <HeroTemplate
                titleKey="academy.hero.title"
                imageKey="academy.webp"
                descriptionKey="academy.hero.paragraph"
            />
            <AcademyAdvantages />
            <AcademyProductsTemplate events={events} eventsCount={eventsCount} />
            <FooterTemplate />
        </>
    );
};

export async function getServerSideProps(ctx: any) {
    try {
        const { data: events } = await calendarApi.getAcademies();

        return {
            props: {
                events: events?.results,
                eventsCount: events?.total_count,
            },
        };
    } catch {
        return {
            props: {
                events: [],
                eventsCount: 0,
            },
        };
    }
}

export default Academy;
